module.exports = __webpack_public_path__ + "static/media/sk2.fbf38e0b.jpg";